<template>
  <transition name="top" appear>
    <q-page-sticky position="top-right" :offset="[11, 11]">
      <q-tooltip self="center right" anchor="center left" :delay="500">{{btns[0].tooltip}}</q-tooltip>
      <q-btn-dropdown
          v-if="aux[0]"
          rounded
          align="right"
          split
          content-class="pop-dd"
          :color="btns[0].color"
          :icon="btns[0].icon"
          @click="btns[0].click"
      >
        <q-btn
            v-for="(btn, index) in aux"
            :key="index"
            v-if="!btn.hide"
            :color="btn.color"
            @click="btn.click"
            :icon="btn.prefix?'':btn.icon"
            round
        >
          <q-tooltip v-if="btn.tooltip" self="center right" anchor="center left" :delay="500">{{btn.tooltip}}</q-tooltip>
          <template v-if="btn.prefix">
            <span>+</span>
            <q-icon :name="btn.icon" size="20px"></q-icon>
          </template>
        </q-btn>
      </q-btn-dropdown>
      <q-btn
        v-else
        round
        :color="btns[0].color"
        :icon="btns[0].icon"
        @click="btns[0].click"
      />
    </q-page-sticky>
  </transition>
</template>
<style>
</style>

<script>

export default {
  name: 'popBtn',
  props: {
    btns: {
      type: Array,
      required: true,
    },
  },
  computed: {
    aux() {
      return this.btns.slice(1).filter(item => !item.hide);
    },
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pop-btn.vue